export default "__VITE_ASSET__D0Z8vkND__"